import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TableCellComponent } from '../../models';
import { BadgeCellProps } from '../badge';

export interface MultiBadgeCellProps {
  limit?: number;
  wrap?: boolean;
  items: BadgeCellProps[];

  click?(): void | Promise<void>;
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  template: `
    <ng-container *ngIf="data">
      <div
        class="flex gap-2"
        tooltipStyle="light"
        tooltipOpenDelay="300"
        [class.flex-wrap]="data.wrap"
        [vsTooltip]="data.limit !== undefined && data.limit < data.items.length ? { template: tooltip } : undefined"
      >
        <ng-container *ngFor="let badge of data.items; let index = index">
          <ng-container *ngIf="data.limit === undefined || index < data.limit">
            <vs-badge
              *ngIf="data.click"
              class="cursor-default max-w-[150px]"
              [theme]="badge.theme"
              [config]="badge"
              (click)="$event.stopPropagation(); _click()"
            >
              <div class="truncate">
                {{ badge.text }}
              </div>
            </vs-badge>

            <vs-badge
              *ngIf="!data.click"
              class="cursor-default max-w-[150px]"
              [theme]="badge.theme"
              [config]="badge"
              [vsTooltip]="badge.tooltipTemplate ? { template: badge.tooltipTemplate } : badge.tooltipText"
              [tooltipStyle]="badge.tooltipStyle || 'dark'"
            >
              <div class="truncate">
                {{ badge.text }}
              </div>
            </vs-badge>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="data.limit !== undefined && data.limit < data.items.length">
          <vs-badge class="cursor-default" theme="default"> +{{ data.items.length - data.limit }} </vs-badge>
        </ng-container>
      </div>

      <ng-template #tooltip>
        <ng-container *ngIf="_config?.header as header">
          <p>{{ header }}</p>
          <vs-divider class="mt-1 mb-2"></vs-divider>
        </ng-container>
        <div class="flex flex-wrap gap-2">
          <vs-badge *ngFor="let badge of data.items" class="cursor-default " [theme]="badge.theme" [config]="badge">
            {{ badge.text }}
          </vs-badge>
        </div>
      </ng-template>
    </ng-container>
  `,
})
export class MultiBadgeCellComponent extends TableCellComponent<MultiBadgeCellProps> {
  async _click() {
    await this.data?.click?.();
  }
}
